import { useCurrentModule } from '../components/ModuleProvider';
export const useDomainItemDesign = isDomainRow => {
  const module = useCurrentModule();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const {
    data: offeringDiscount
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOfferingDiscount({});
  return isDomainRow && experiments.isEnabled('specs.premium.domainItemDesign') && Boolean(offeringDiscount == null ? void 0 : offeringDiscount.hasSale);
};
//# sourceMappingURL=useDomainItemDesign.js.map